import { render, staticRenderFns } from "./detailRoundv.vue?vue&type=template&id=35ef460d&scoped=true"
import script from "./detailRoundv.vue?vue&type=script&lang=js"
export * from "./detailRoundv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ef460d",
  null
  
)

export default component.exports